<div class="custom-mat-dialog-form">
    <button mat-icon-button class="cross-button" [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
    </button>

    <div style="justify-content: space-between; display: flex; align-items: center;">
        <div class="popup-header">
            <h3>{{title}}</h3>
        </div>

        <div class="space-left" style="margin-left:400px; margin-right:15px;">
            <mat-form-field class="search-input max-30w" style="width: 25vw;">
                <mat-label>Search</mat-label>
                <input placeholder="Filter" id="filter"
                    matInput
                    aria-label="Search"
                    (keyup)="applyFilter($event)">
            </mat-form-field>
        </div>
    </div>

    <div class="popup-table-container">
        <table mat-table
           [dataSource]="dataSource"
           multiTemplateDataRows
           class="mat-elevation-z8 mat-table-custom" id="contractbundletranslationauditlist">

        <ng-container matColumnDef="Feature">
            <th mat-header-cell *matHeaderCellDef> Feature </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.Feature"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="LocalContractLine">
            <th mat-header-cell *matHeaderCellDef> Local Contract Translation </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.LocalContractLine"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="CreatedByUser">
            <th mat-header-cell *matHeaderCellDef> Created By </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.CreatedByUser"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="CreatedAtUtc">
            <th mat-header-cell *matHeaderCellDef> Created At (UTC) </th>
            <td mat-cell *matCellDef="let element">
                <p>{{element.CreatedAtUtc | date:'yyyy-MM-dd HH:mm'}}</p>
            </td>
        </ng-container>

        <ng-container matColumnDef="ChangedByUser">
            <th mat-header-cell *matHeaderCellDef> Changed By </th>
            <td mat-cell *matCellDef="let element">
                <p [innerHTML]="element.ChangedByUser"></p>
            </td>
        </ng-container>

        <ng-container matColumnDef="ChangedAtUtc">
            <th mat-header-cell *matHeaderCellDef> Changed At (UTC) </th>
            <td mat-cell *matCellDef="let element">
                <p>{{element.ChangedAtUtc | date:'yyyy-MM-dd HH:mm'}}</p>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="opmode-item"></tr>

        </table>
    </div>
</div>
